import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./BlendingSystem.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import { generateBlend } from "../engine/blendEngine";
import BlendLaboratory from "./BlendLaboratory";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function BlendingSystem() {

    useEffect(() => {
    
      trackPageVisit("BlendingSystem");
    
    }, []);
  
     const {  valves, toggleValve, transmitters, updateTransmitter} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
const [showBlendLaboratory, setShowBlendLaboratory] = useState(false);    
const [currentBlend, setCurrentBlend] = useState(null);




  const DEFAULT_VALVES = {
  FCV_1401: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("BlendingSystem_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1401: { ...DEFAULT_VALVES.FCV_1401, ...parsed.FCV_1401 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("BlendingSystem_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


useEffect(() => {

    console.log(generateBlend());

}, []);

const blend = generateBlend();

console.log(blend);


/* ==========================================
SAVE CURRENT REFINERY CRUDE BLEND
========================================== */

localStorage.setItem(
    "CURRENT_CRUDE_BLEND",
    JSON.stringify(blend)     // use your actual blend object variable
);


const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================


  
    const [FIC_13010, setFIC_13010] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_13010")) || 0;
            setFIC_13010(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);
  
    const [FIC_13012, setFIC_13012] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_13012")) || 0;
            setFIC_13012(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [FIC_13020, setFIC_13020] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_13020")) || 0;
            setFIC_13020(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [FIC_13017, setFIC_13017] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_13017")) || 0;
            setFIC_13017(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);








/* ==========================================
READ CURRENT BLEND
========================================== */

useEffect(() => {

    const storedBlend = localStorage.getItem(
        "CURRENT_CRUDE_BLEND"
    );

    if (storedBlend) {

        setCurrentBlend(
            JSON.parse(storedBlend)
        );

    }

}, []);


/* ==========================================
STORE CRUDE NOW INSIDE V-1501
========================================== */

useEffect(() => {

    const interval = setInterval(() => {

        const storedBlend = localStorage.getItem(
            "CURRENT_CRUDE_BLEND"
        );

        if (storedBlend) {

            setCurrentBlend(
                JSON.parse(storedBlend)
            );

        }

    }, 500);

    return () => clearInterval(interval);

}, []);




  const xv1401Open = !valves?.XV_1401;
  const xv1402Open = !valves?.XV_1402;
  const xv1403Open = !valves?.XV_1403;
  const xv1404Open = !valves?.XV_1404;
  const xv1405Open = !valves?.XV_1405;
  const xv1406Open = !valves?.XV_1406;
  const xv1407Open = !valves?.XV_1407;
  const xv1408Open = !valves?.XV_1408;



  const FIC_1401 = FIC_13010;
  const FIC_1402 = FIC_13012;
  const FIC_1403 = FIC_13020;
  const FIC_1404 = FIC_13017;

  const FIC_1405a = (xv1401Open ? FIC_1401: 0) + (xv1402Open ? FIC_1402 : 0) +(xv1403Open ? FIC_1403 : 0) + (xv1404Open ? FIC_1404 : 0);

  /* =========================================================
              SPLITTING OF MAIN BLENDING LINE
========================================================= */

const openMainBlendingLine =
[
  xv1405Open,
  xv1407Open
].filter(Boolean).length;

const FIC_1405 = 
  xv1405Open
    ? FIC_1405a / openMainBlendingLine
    : 0;

const FIC_1406 =
  xv1407Open
    ? FIC_1405a / openMainBlendingLine
    : 0;




/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});



/* =========================================================
   P-1401 PUMP STATUS
========================================================= */

const isP1401AOn =
pumpData?.["P-1401A"]?.running ?? false;


const isP1401BOn =
pumpData?.["P-1401B"]?.running ?? false;



/* =========================================================
   ACTIVE PUMPS
========================================================= */

const P1401A_Active = isP1401AOn;

const P1401B_Active = isP1401BOn;


const pumpRunning =
P1401A_Active ||
P1401B_Active;



/* =========================================================
   PUMP CAPACITY
========================================================= */

const TOTAL_CAPACITY_1401 = 15.453;



/* =========================================================
   FCV-1401 CONTROL VALVE
========================================================= */

const FCV1401_Opening =
Number(
 valveData?.FCV_1401?.opening || 0
);

/*
   Convert valve opening to flow demand

   100% = full flow
   0%   = closed
*/


const valveFactor =
FCV1401_Opening / 100;



/* =========================================================
   SUCTION AVAILABLE
========================================================= */

const suctionAvailable =
(
 xv1406Open ||
 xv1408Open
);


/* =========================================================
   DISCHARGE FLOW TARGET
========================================================= */

const targetFIC_1407 =
(
 pumpRunning &&
 suctionAvailable
)
?
(
 TOTAL_CAPACITY_1401 *
 valveFactor
)
:
0;




/* =========================================================
   FIC-1407 FLOW RESPONSE
========================================================= */

const FIC_1407 = processData?.FIC_1407 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1407_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1407 || 0);

    const systemActive =

    (P1401A_Active || P1401B_Active);

    const target =
      systemActive
        ? targetFIC_1407
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1407: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_1407,
  P1401A_Active,
  P1401B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1407_LastUpdate",
    String(Date.now())
  );

}, [FIC_1407]);



useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        prev.FIC_1407 || 0;

      const next =
        current +
        (
          targetFIC_1407 -
          current
        ) * 0.12;

      return {
        ...prev,
        FIC_1407: Number(
          next.toFixed(3)
        )
      };

    });

  }, 500);

  return () =>
    clearInterval(timer);

}, [
  targetFIC_1407,
  setProcessData
]);



/* =========================================================
   V-1401 SUCTION FLOW
========================================================= */
const FIC_1408 = (pumpRunning && xv1406Open) ? FIC_1407 : 0.003;

/* =========================================================
   V-1402 SUCTION FLOW
========================================================= */
const FIC_1409 = (pumpRunning && xv1408Open) ? FIC_1407 : 0.003;

/* =========================================================
   PT-1407 PRESSURE
   FCV controls discharge pressure

========================================================= */
const PT_1407 =

    (pumpRunning)

    ?

    (0.03 + (1.8 * valveFactor))

    :

    0.03;


/* =========================================================
   TT-1407
========================================================= */
const TT_1407 = (pumpRunning) ? 37 : 25;



    const TT_1401 = xv1405Open ? 37.983 : 35.433;
    const TT_1402 = xv1407Open ? 37.983 : 35.433;



useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1407 === FIC_1407 &&
    current.FIC_1408 === FIC_1408 &&
    current.FIC_1409 === FIC_1409 &&
    current.FIC_1405 === FIC_1405 &&
    current.FIC_1406 === FIC_1406
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1407, FIC_1405, FIC_1406, FIC_1408, FIC_1409,
    }
  });

}, [FIC_1407, FIC_1405, FIC_1406, FIC_1408, FIC_1409,]);







  return (
    <div className="BlendingSystem-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "235px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 293px",
          zIndex: 10,
        }}
      >
        CRUDE BLENDING TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1401 */}
      <Valve
        className="XV-1401"
        tag="XV_1401"
        x={229}
        y={389}
        isClosed={valves.XV_1401}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1402 */}
      <Valve
        className="XV-1402"
        tag="XV_1402"
        x={174}
        y={446}
        isClosed={valves.XV_1402}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1403 */}
      <Valve
        className="XV-1403"
        tag="XV_1403"
        x={198}
        y={539}
        isClosed={valves.XV_1403}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1404 */}
      <Valve
        className="XV-1404"
        tag="XV_1404"
        x={257}
        y={539}
        isClosed={valves.XV_1404}
        toggle={toggleValve}
        r={90}
      />
      
       {/* XV-1405 */}
      <Valve
        className="XV-1405"
        tag="XV_1405"
        x={325}
        y={389}
        isClosed={valves.XV_1405}
        toggle={toggleValve}
        r={90}
      />
      
       {/* XV-1406 */}
      <Valve
        className="XV-1406"
        tag="XV_1406"
        x={641}
        y={389}
        isClosed={valves.XV_1406}
        toggle={toggleValve}
        r={90}
      />
      
       {/* XV-1407 */}
      <Valve
        className="XV-1407"
        tag="XV_1407"
        x={772}
        y={389}
        isClosed={valves.XV_1407}
        toggle={toggleValve}
        r={90}
      />
      
       {/* XV-1408 */}
      <Valve
        className="XV-1408"
        tag="XV_1408"
        x={1083}
        y={389}
        isClosed={valves.XV_1408}
        toggle={toggleValve}
        r={90}
      />
      



      
        
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1401 */}
        <div
            style={{ position: "absolute", left: 1008, top: 597}}
            onMouseEnter={() => setHoveredValve("FCV_1401")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1401")}
          >

            {hoveredValve === "FCV_1401" && (
              <div style={tagStyle}>
                FCV_1401
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1401">
                    
          <defs>
            <linearGradient id="metal_1401">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1401)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1401)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}




          <button
              className="receipt-btn print"
              onClick={() => setShowBlendLaboratory(true)}

              style={{
            position: "absolute",
            top: "200px",
            left: "40px",
            padding: "3px 4px",
            background: "#240ee7",
            color: "#faf3f3",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 500
          }}
          >
              🧪 BLEND LABORATORY
          </button>

              {
              showBlendLaboratory &&
              <BlendLaboratory
                  onClose={() =>
                      setShowBlendLaboratory(false)
                  }
              />
              }
           

      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1401?.opening || 0)}
        x={1031}
        y={642}
      />



        <Transmitter
          tag="FIC_1401"
          value={[FIC_1401]}
          x={125}
          y={324}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM TRANSFER PUMPS (P-1304A/B) FROM V-1301 TO BLENDING TANK (V-1401) OR BLENDING TANK (V-1402)"
         />

        <Transmitter
          tag="FIC_1402"
          value={[FIC_1402]}
          x={115}
          y={394}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM TRANSFER PUMPS (P-1304A/B) FROM V-1302 TO BLENDING TANK (V-1401) OR BLENDING TANK (V-1402)"
         />

        <Transmitter
          tag="FIC_1403"
          value={[FIC_1403]}
          x={115}
          y={554}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM TRANSFER PUMPS (P-1304A/B) FROM V-1303 TO BLENDING TANK (V-1401) OR BLENDING TANK (V-1402)"
         />

        <Transmitter
          tag="FIC_1404"
          value={[FIC_1404]}
          x={125}
          y={624}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM TRANSFER PUMPS (P-1304A/B) FROM V-1304 TO BLENDING TANK (V-1401) OR BLENDING TANK (V-1402)"
         />

        <Transmitter
          tag="FIC_1405"
          value={[FIC_1405]}
          x={275}
          y={244}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM CRUDE TANKS (V-1301, V-1302, V-1303, V-1304) TO CRUDE BLENDING TANK 1 (V-1401)"
         />

        <Transmitter
          tag="FIC_1406"
          value={[FIC_1406]}
          x={745}
          y={244}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM CRUDE TANKS (V-1301, V-1302, V-1303, V-1304) TO CRUDE BLENDING TANK 1 (V-1402)"
         />

        <Transmitter
          tag="FIC_1407"
          value={[FIC_1407]}
          x={1105}
          y={593}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM CRUDE BLENDING TRANSFER PUMPS (P-1401A/B) TO DAY TANK"
         />

        <Transmitter
          tag="TT_1407"
          value={[TT_1407]}
          x={1105}
          y={638}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE ON TANK V-1304"
         />

        <Transmitter
          tag="PT_1407"
          value={[PT_1407]}
          x={905}
          y={612}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE TRANSFER PUMPS (P-1303A/B) MINIMUM FLOW BYEPASS LINE FROM V-1303 TO BLENDING TANK OR DAY TANK"
         />

         <Transmitter
          tag="TT_1401"
          value={[TT_1401]}
          x={392}
          y={68}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE BLENDING TANK V-1401"
         />

         <Transmitter
          tag="TT_14012"
          value={[TT_1402]}
          x={832}
          y={68}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE BLENDING TANK V-1402"
         />














    <LevelTransmitterIndicator
      tag="LT_1401"
      totalLevel={70000}
      inflows={[FIC_1405]}
      outflows={[FIC_1408]}
      responseFactor={0.05}
      columnX={559}
      columnY={139}
      columnWidth={30}
      columnHeight={178}
      textX={610}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1401"
      totalLevel={70000}
      inflows={[FIC_1405]}
      outflows={[FIC_1408]}
      responseFactor={0.05}
      columnX={396}
      columnY={139}
      columnWidth={197}
      columnHeight={178}
      textX={610}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1402"
      totalLevel={70000}
      inflows={[FIC_1406]}
      outflows={[FIC_1409]}
      inflowTags={["FIC_1406"]}
      outflowTags={["FIC_1409"]}
      responseFactor={0.05}
      columnX={1006}
      columnY={137}
      columnWidth={30}
      columnHeight={178}
      textX={1046}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1402"
      totalLevel={70000}
      inflows={[FIC_1406]}
      outflows={[FIC_1409]}
      inflowTags={["FIC_1406"]}
      outflowTags={["FIC_1409"]}
      responseFactor={0.05}
      columnX={842}
      columnY={139}
      columnWidth={192}
      columnHeight={178}
      textX={1046}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />






          <Pump
              tag="P-1401A"
              x={802}
              y={567}
              rpm={1800}
              bladeCount={pumpData?.["P-1401A"]?.bladeCount || 3}
              size={pumpData?.["P-1401A"]?.size || 43}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1401B"
              x={802}
              y={658}
              rpm={1800}
              bladeCount={pumpData?.["P-1401B"]?.bladeCount || 3}
              size={pumpData?.["P-1401B"]?.size || 43}
              onClick={openPumpPanel}
            />


    </div>
  );
}

export default BlendingSystem;